import { useState } from "react";
import axios from '../api/axiosInstance';

function getLocalDateTimeString() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

function AdminAddBloodSugarModal({ open, user, onClose, onSuccess }) {
  const [form, setForm] = useState({
    glucose: "",
    type: "0",
    notes: "",
    recordedAt: getLocalDateTimeString(),
  });

  const token = localStorage.getItem("token");

  const handleSubmit = async () => {
    try {
      await axios.post(
        "/api/BloodSugar",
        {
          userId: user.userId,
          ...form,
          type: parseInt(form.type),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      alert("新增成功");
      onClose();
      if (onSuccess) onSuccess();
    } catch {
      alert("新增失敗");
    }
  };

  if (!open || !user) return null;

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog" style={{ zIndex: 1055 }}>
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">新增血糖 - {user.name}</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">

              <div className="mb-2">
                <label className="form-label">紀錄時間</label>
                <input
                  type="datetime-local"
                  className="form-control mb-2"
                  value={form.recordedAt}
                  onChange={(e) => setForm({ ...form, recordedAt: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">血糖值</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  className="form-control mb-2"
                  value={form.glucose}
                  onChange={(e) => setForm({ ...form, glucose: e.target.value })}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">類別</label>
                <select
                  className="form-select mb-2"
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                >
                  <option value="0">空腹</option>
                  <option value="1">飯後</option>
                </select>
              </div>
              <div className="mb-2">
                <label className="form-label">備註</label>
                <input
                  type="text"
                  className="form-control mb-2"
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>取消</button>
              <button className="btn btn-primary" onClick={handleSubmit}>送出</button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }}></div>
    </>
  );
}

export default AdminAddBloodSugarModal;
